module.exports = __webpack_public_path__ + "static/media/Carosel HO 3.d1b94fdf.svg";